<template>
  <div class="containerContract">
    <div class="contentContract">
      <div class="title">
        <span>Enviar boleto</span>
      </div>
      <div class="rowContainer">
        <span> <b-icon-search></b-icon-search> Selecione o Curso:</span>
        <div class="searchInputFin">
          <InputSelect
            label="Cursos"
            :items="boxCourses"
            valueField="id"
            textField="name"
            :dataSelect.sync="selectCourse"
            @selectedIten="choicedCourse($event)"
            ref="idStudent"
          />
          <div class="searchInputAll" style="justify-content: flex-end">
            <button class="searchAll" @click="clear()">
              <b-icon-arrow-counterclockwise
                scale="1.5"
                style="margin-right: 10px"
              />
              Limpar
            </button>
          </div>
        </div>
        <span v-if="searchStudents && searchStudents.length > 0">
          Alunos vinculados ao curso :</span
        >
        <span
          style="
            font-size: 20px;
            font-weight: bold;
            width: 100%;
            text-align: center;
            color: #0188c8;
          "
          >{{ this.nameCourse.name }}</span
        >
        <div
          class="ContentTable"
          style="
            color: #3a4750;
            width: 100%;
            max-height: 80vh;
            flex-wrap: nowrap;
          "
          v-if="searchStudents && searchStudents.length > 0"
        >
          <div
            v-for="students in searchStudents"
            :key="students.id"
            @click="selectStudent(students.id)"
            class="rowStu"
          >
            <div class="celTable" style="width: 35%; min-width: 30%">
              <span class="textEllipsis">
                <strong>Nome: </strong>
                <strong
                  style="
                    color: #0188c8;
                    font-weight: bold;
                    text-transform: uppercase;
                    padding-left: 3px;
                  "
                  >{{ students.name }}</strong
                >
              </span>
              <span class="textEllipsis">
                <strong>CPF / RG : </strong>
                {{ students.cpf }} / {{ students.rg }}
              </span>
            </div>
            <div class="celTable" style="width: 20%; min-width: 20%">
              <span
                class="wtsTd textEllipsis"
                @click.stop="redirectWhatsApp(students.phone)"
              >
                <strong>Whatsapp: </strong>
                {{ students.phone || "(00) 0000-0000" }}
                <div v-if="students.phone">
                  <img class="whatsapp" :src="whatsapp" />
                </div>
              </span>
              <span class="textEllipsis">
                <strong>Email: </strong>
                {{ students.email || "--" }}
              </span>
            </div>
            <div class="celTable" style="width: 45%; min-width: 35%">
              <span class="textEllipsis"
                ><strong>Endereço: </strong>{{ students.address }} -
                {{ students.district }} , {{ students.number || "S/N" }}</span
              >
              <span class="textEllipsis"
                ><strong>Cidade: </strong>{{ students.city || "--" }}
                {{ students.uf }} - CEP :{{ students.cep || "--" }}</span
              >
            </div>
            <div class="celTableActions">
              <span
                class="celInfos"
                style="padding: 0px; height: auto"
                v-b-tooltip.hover.right="'Anexar Boleto'"
                @click.stop="openBoletoModal(students)"
              >
                <img class="teach" :src="send" />
              </span>
              <span
                v-if="isBoletoAnexado(students.id)"
                style="color: green; font-size: 12px; margin-top: 5px"
              >
                ✓ Anexado
              </span>
            </div>
          </div>
        </div>
        <div class="tableAddProductsAny" v-else>
          <span class="anyProd">Nenhum curso selecionado </span>
        </div>
        <div
          class="searchInputAll"
          style="justify-content: flex-end; margin-top: 15px; width: 100%"
          v-if="boletosParaEnvio.length > 0"
        >
          <button
            class="btnConfirm"
            @click="enviarEmMassa"
            style="width: 200px; position: relative"
          >
            Enviar {{ boletosParaEnvio.length }} Boleto(s) em Massa
            <b-spinner
              small
              v-if="spinGeneral"
              style="position: absolute; right: 10px"
            />
          </button>
        </div>
      </div>
      <div class="rowContainer" v-if="moreInfoStudent">
        <span>
          <b-icon-person-lines-fill></b-icon-person-lines-fill> Dados do Aluno
          Selecionado</span
        >
        <span
          style="
            font-size: 20px;
            font-weight: bold;
            width: 100%;
            text-align: center;
            color: #0188c8;
          "
          >{{ this.moreInfoStudent.name }}</span
        >
        <div class="rowContainer">
          <div class="rowStuMoreInfo">
            <div class="celTable" style="width: 30%; min-width: 30%">
              <span class="textEllipsis">
                <strong>Nome: </strong>
                <strong
                  style="
                    color: #0188c8;
                    font-weight: bold;
                    text-transform: uppercase;
                    padding-left: 3px;
                  "
                  >{{ this.moreInfoStudent.name }}</strong
                >
              </span>
              <span class="textEllipsis">
                <strong>CPF / RG : </strong>
                {{ this.moreInfoStudent.cpf }} / {{ this.moreInfoStudent.rg }}
              </span>
            </div>
            <div class="celTable" style="width: 25%; min-width: 25%">
              <span
                class="wtsTd textEllipsis"
                @click.stop="redirectWhatsApp(this.moreInfoStudent.phone)"
              >
                <strong>Whatsapp: </strong>
                {{ this.moreInfoStudent.phone || "(00) 0000-0000" }}
                <div v-if="this.moreInfoStudent.phone">
                  <img class="whatsapp" :src="whatsapp" />
                </div>
              </span>
              <span class="textEllipsis">
                <strong>Email: </strong>
                {{ this.moreInfoStudent.email || "--" }}
              </span>
            </div>
            <div class="celTable" style="width: 35%; min-width: 35%">
              <span class="textEllipsis"
                ><strong>Endereço: </strong>{{ this.moreInfoStudent.address }} -
                {{ this.moreInfoStudent.district }} ,
                {{ this.moreInfoStudent.number || "S/N" }}</span
              >
              <span class="textEllipsis"
                ><strong>Cidade: </strong
                >{{ this.moreInfoStudent.city || "--" }}
                {{ this.moreInfoStudent.uf }} - Cep:
                {{ this.moreInfoStudent.cep }}</span
              >
            </div>
          </div>
          <span> <b-icon-cash-stack /> Histórico</span>
          <div class="rowContent" style="flex-direction: column">
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                bottom: 10px;
                position: relative;
                align-items: center;
              "
            >
              <div class="radio-input">
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="this.moreInfoStudent.isStudentOfOmega"
                    class="cyberpunk-checkbox"
                  />
                  Aluno Ômega</label
                >
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="this.moreInfoStudent.isOldStudentOfOmega"
                    class="cyberpunk-checkbox"
                  />
                  Ex-Aluno Ômega</label
                >
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="this.moreInfoStudent.isSchoolPublic"
                    class="cyberpunk-checkbox"
                  />
                  Escola pública</label
                >
                <label class="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    v-model="this.moreInfoStudent.isResideForaVicosa"
                    class="cyberpunk-checkbox"
                  />
                  Reside fora de viçosa</label
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="ContentTable"
          style="color: #3a4750; width: 100%"
          v-if="allcourses && allcourses.length > 0"
        >
          <div
            v-for="course in allcourses"
            :key="course.id"
            @click="openBoleto(course)"
            :class="`conentClientRows ${handleTableBorderColor(course.status)}`"
          >
            <span
              class="notResult"
              :style="`width: 70px; height: 70px; background-image: url(${
                course.url || notImg
              }); background-repeat: no-repeat; background-size: contain; background-position: center center`"
            />
            <div class="rowCLientDiv">
              <div
                class="rowClient"
                style="border-bottom: 1px solid #e6e6e6; height: 100%"
              >
                <div class="celTable" style="width: 40%; min-width: 40%">
                  <span class="textEllipsis">
                    <strong
                      style="
                        color: #0188c8;
                        font-weight: bold;
                        text-transform: uppercase;
                        padding-left: 3px;
                      "
                      >{{ course.courseName }}</strong
                    >
                  </span>
                </div>
                <div class="celTable" style="width: 30%; min-width: 30%">
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px"
                      >Pagamento Material: </strong
                    >{{ course.paymentMaterial }}</span
                  >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px"
                      >Pagamento Curso: </strong
                    >{{ course.paymentCourse }}</span
                  >
                </div>
                <div
                  class="celTable"
                  style="
                    width: 30%;
                    min-width: 30%;
                    align-items: flex-end;
                    padding-right: 30px;
                  "
                >
                  <span
                    v-if="
                      course.paymentMaterial !== 'A Prazo' &&
                      course.materialPriceOmega
                    "
                    class="textEllipsis"
                    style="
                      color: #0188c8;
                      font-weight: bold;
                      text-transform: uppercase;
                    "
                    ><strong>Valor: </strong
                    >{{
                      course.materialPriceOmega.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}</span
                  >
                  <span
                    v-else
                    class="textEllipsis"
                    style="
                      color: #0188c8;
                      font-weight: bold;
                      text-transform: uppercase;
                    "
                    ><strong>Valor: </strong>
                    {{ course.qtdInstallmentsMaterialOmega }} X
                    {{
                      course.pricingInstallmentsMaterialOmega
                        ? course.pricingInstallmentsMaterialOmega.toLocaleString(
                            "pt-br",
                            {
                              style: "currency",
                              currency: "BRL",
                            }
                          )
                        : course.pricingInstallmentsMaterialOmega
                    }}</span
                  >
                  <span
                    class="textEllipsis"
                    style="
                      color: #0188c8;
                      font-weight: bold;
                      text-transform: uppercase;
                    "
                    v-if="course.paymentCourse !== 'A Prazo' && course.price"
                    ><strong>Valor: </strong>
                    {{
                      course.materialPriceOmega.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </span>
                  <span
                    v-else
                    class="textEllipsis"
                    style="
                      color: #0188c8;
                      font-weight: bold;
                      text-transform: uppercase;
                    "
                    ><strong>Parcelas: </strong> {{ course.qtdInstallments }} X
                    {{
                      course.pricingInstallments
                        ? course.pricingInstallments.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        : course.pricingInstallments
                    }}</span
                  >
                </div>
              </div>
              <div
                class="rowClient"
                v-if="course.bondsmans || course.responsibles"
                style="justify-content: flex-start"
              >
                <div
                  class="celTable"
                  style="width: 40%; min-width: 40%"
                  v-if="course.bondsmans"
                >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px">Fiador: </strong
                    >{{ course.bondsmans.name || "-" }}</span
                  >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px">CPF Fiador: </strong
                    >{{ course.bondsmans.cpf || "-" }}</span
                  >
                </div>
                <div
                  class="celTable"
                  v-if="course.bondsmans"
                  style="width: 30%; min-width: 30%"
                >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px"
                      >Telefone Fiador: </strong
                    >{{ course.bondsmans.telefone || "-" }}</span
                  >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px">Email Fiador: </strong
                    >{{ course.bondsmans.email || "-" }}</span
                  >
                </div>
                <div
                  class="celTable"
                  style="width: 40%; min-width: 40%"
                  v-if="course.responsibles"
                >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px">Responsável: </strong
                    >{{ course.responsibles.name || "-" }}</span
                  >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px"
                      >CPF Responsável: </strong
                    >{{ course.responsibles.cpf || "-" }}</span
                  >
                </div>
                <div
                  class="celTable"
                  v-if="course.responsibles"
                  style="width: 30%; min-width: 30%"
                >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px"
                      >Telefone Responsável: </strong
                    >{{ course.responsibles.telefone || "-" }}</span
                  >
                  <span class="textEllipsis"
                    ><strong style="padding-right: 5px"
                      >Email Responsável: </strong
                    >{{ course.responsibles.email || "-" }}</span
                  >
                </div>
              </div>
            </div>
            <div class="celTableActions">
              <span
                class="celInfos"
                v-b-tooltip.hover.right="'Enviar Boleto'"
                @click.stop="openBoleto(course)"
                ><img
                  class="teach"
                  @click.stop="openBoleto(course)"
                  :src="send"
              /></span>
              <span
                v-if="course.isBoleto"
                style="
                  display: flex;
                  align-items: center;
                  color: green;
                  font-size: 12px;
                "
              >
                Enviado
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div v-if="spinGeneral" class="loadingLazy">
          <div class="loader"></div>
        </div>
        <b-modal id="modal-boleto" hide-footer hide-header centered>
          <div>
            <div class="contentTitle">
              <h6 class="titleModalReversalOrDelete">
                Anexar Boleto para
                {{
                  alunoSelecionadoParaBoleto
                    ? alunoSelecionadoParaBoleto.name
                    : ""
                }}
              </h6>
            </div>
            <section
              style="
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 20px;
                margin-top: 20px;
                margin-bottom: 15px;
                padding: 0 10px;
              "
            >
              <div style="width: 100%">
                <label for="file-upload" class="file-label">
                  Escolha o boleto para anexar:
                </label>
                <b-form-file
                  id="file-upload"
                  v-model="uploadedFile"
                  placeholder="Nenhum arquivo selecionado"
                  drop-placeholder="Solte o arquivo aqui..."
                  accept=".pdf, .jpg, .jpeg, .png"
                  browse-text="Anexar"
                ></b-form-file>
              </div>
            </section>

            <div class="btnsModalActions">
              <button class="btnCancel" @click="$bvModal.hide('modal-boleto')">
                Cancelar
              </button>
              <button
                class="btnConfirm"
                style="position: relative"
                @click="anexarBoleto"
              >
                Anexar
              </button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import CourseService from "../../services/course";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import notImg from "../../assets/notImg.png";
import send from "../../assets/send1.svg";
import whatsapp from "../../assets/whatsapp.svg";

export default {
  components: {
    InputSelect,
  },
  data() {
    return {
      notImg: notImg,
      whatsapp: whatsapp,
      send: send,
      allStudents: [],
      allcourses: [],
      boxCourses: [],
      course: {},
      confirmDelete: false,
      spinGeneral: false,
      spinLoadingActionsButton: false,
      uploadedFile: null,
      selectCourse: null,
      searchStudents: [],
      moreInfoStudent: null,
      boletosParaEnvio: [],
      alunoSelecionadoParaBoleto: null,
      nameCourse: "",
    };
  },

  methods: {
    handleTableBorderColor(status) {
      const colors = {
        ["cursando"]: "borderOpen",
        ["finalizado"]: "borderFinished",
      };

      return colors[status];
    },

    async openBoletoModal(student) {
      this.spinGeneral = true;
      try {
        const result = await CourseService.getStudentById(student.id);
        const allStudentCourses = result.data.studentCourse;
        const targetCourse = allStudentCourses.find(
          (sc) => sc.courseId === this.selectCourse
        );

        if (!targetCourse) {
          this.$toast.open({
            message:
              "Matrícula não encontrada para este aluno no curso selecionado.",
            type: "error",
          });
          return;
        }

        const studentWithMatriculaId = {
          ...student,
          studentCourseId: targetCourse.id,
        };

        this.alunoSelecionadoParaBoleto = studentWithMatriculaId;
        this.$bvModal.show("modal-boleto");
      } catch (error) {
        console.error("Erro ao buscar dados da matrícula:", error);
        this.$toast.open({
          message: "Não foi possível obter os dados da matrícula.",
          type: "error",
        });
      } finally {
        this.spinGeneral = false;
      }
    },
    anexarBoleto() {
      if (!this.uploadedFile) {
        alert("Por favor, anexe um arquivo.");
        return;
      }

      const boletoInfo = {
        studentId: this.alunoSelecionadoParaBoleto.id,
        studentCourseId: this.alunoSelecionadoParaBoleto.studentCourseId,
        file: this.uploadedFile,
      };

      const existingIndex = this.boletosParaEnvio.findIndex(
        (b) => b.studentId === boletoInfo.studentId
      );
      if (existingIndex !== -1) {
        this.boletosParaEnvio.splice(existingIndex, 1, boletoInfo);
      } else {
        this.boletosParaEnvio.push(boletoInfo);
      }

      this.$toast.open({
        message: "Boleto anexado com sucesso!",
        type: "success",
      });
      this.uploadedFile = null;
      this.$bvModal.hide("modal-boleto");
    },

    async enviarEmMassa() {
      if (!confirm(`Deseja enviar ${this.boletosParaEnvio.length} boleto(s)?`))
        return;

      this.spinGeneral = true;
      let successCount = 0;
      let errorCount = 0;

      for (const boleto of this.boletosParaEnvio) {
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(boleto.file);
        });

        const body = {
          id: boleto.studentCourseId,
          documents: [{ base64, key: "boleto" }],
          typeRef: "student-course",
        };

        try {
          await CourseService.uploadFiles(body);
          successCount++;
        } catch (error) {
          errorCount++;
          console.error(
            `Erro ao enviar boleto para o aluno ID ${boleto.studentId}:`,
            error
          );
        }
      }

      this.$toast.open({
        message: `${successCount} boletos enviados, ${errorCount} falharam.`,
        type: errorCount > 0 ? "warning" : "success",
      });

      this.boletosParaEnvio = [];
      this.spinGeneral = false;
    },

    async selectStudent(idStudent) {
      try {
        this.spinGeneral = true;
        const result = await CourseService.getStudentById(idStudent);
        this.moreInfoStudent = result.data;

        this.allcourses = result.data.studentCourse.filter(
          (sc) => sc.courseId === this.selectCourse
        );
      } catch (error) {
        console.error("Erro ao buscar alunos do curso:", error);
      } finally {
        this.spinGeneral = false;
      }
    },
    isBoletoAnexado(studentId) {
      return this.boletosParaEnvio.some((b) => b.studentId === studentId);
    },
    async choicedCourse(id) {
      try {
        this.spinGeneral = true;
        this.clear();
        this.nameCourse = this.boxCourses.find((c) => c.id === id);
        this.selectCourse = id;
        const data = await CourseService.allStudentTheCourse(id);
        this.searchStudents = data.data;
      } catch (error) {
        console.error("Erro ao buscar alunos do curso:", error);
      } finally {
        this.spinGeneral = false;
      }
    },
    redirectWhatsApp(number) {
      if (number) {
        const formatedNumber = number.replace(/\D/g, "");
        const url = `https://wa.me/55${formatedNumber}`;
        window.open(url, "_blank");
      }
      1;
    },

    clear() {
      this.searchStudents = [];
      this.moreInfoStudent = null;
      this.allcourses = [];
      this.boletosParaEnvio = [];
      this.selectCourse = null;
    },
    async readCourses() {
      try {
        const { data } = await CourseService.comboboxCourses();
        this.boxCourses = data;
      } catch (error) {
        console.error("Erro ao carregar cursos:", error);
      }
    },
  },
  mounted() {
    this.readCourses();
  },
};
</script>
<style scoped>
.teach {
  width: 35px;
  height: 30px;
}

.containerContract {
  display: flex;
  padding-top: 70px;
  width: 90%;
  margin-left: 100px;
  justify-content: center;
}

.contentContract {
  font-size: 13px;
  display: flex;
  flex-direction: column;
  width: 90%;
  padding-bottom: 50px;
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.borderFinished {
  border-left: solid 5px green;
}

.borderOpen {
  border-left: solid 5px rgb(0, 81, 169);
}

#input_file {
  display: none;
}

.cyberpunk-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #0188c8;
  border-radius: 5px;
  background-color: transparent;
  display: inline-block;
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}

.cyberpunk-checkbox:before {
  content: "";
  background-color: #0188c8;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 10px;
  height: 10px;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}

.cyberpunk-checkbox:checked:before {
  transform: translate(-50%, -50%) scale(1);
}

.cyberpunk-checkbox-label {
  font-size: 14px;
  color: #454545;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  flex-wrap: wrap;
}

.rowClient {
  display: flex;
  align-items: center;
  border-radius: 4px;
  text-align: center;
  height: 100%;
  padding: 2px 10px;
  width: 100%;
  cursor: context-menu;
  font-size: 12px;
  position: relative;
}

.rowClient:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}
.rowCLientDiv:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.rowCLientDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  text-align: center;
  gap: 5px;
  width: 90%;
  padding: 2px 10px;
  cursor: context-menu;
  font-size: 12px;
  height: 100%;
}
.conentClientRows:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.conentClientRows {
  display: flex;
  height: 120px;
  width: 100%;
  align-items: center;
  background: rgba(245, 245, 245, 0.608);
  border-radius: 4px;
  text-align: center;
  gap: 5px;
  padding: 2px 10px;
  cursor: context-menu;
  font-size: 12px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.131);
  justify-content: space-between;
}

.rowStuMoreInfo {
  display: flex;
  align-items: center;
  background: rgba(245, 245, 245, 0.608);
  text-align: center;
  font-size: 12px;
  width: 100%;
}

.rowStu {
  display: flex;
  align-items: center;
  background: rgba(245, 245, 245, 0.608);
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  justify-content: space-between;
  height: 65px;
  gap: 20px;
  padding: 2px 10px;
  cursor: pointer;
  font-size: 12px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.131);
}

.rowStu:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.celTable span {
  font-weight: 100 !important;
}

.ContainerSearchInput {
  display: flex;
  align-items: center;
  height: 37px;
  width: 100%;
  justify-content: space-between;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.contentTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 10px;
  background-color: #0188c8;
  border-radius: 5px;
  color: white;
  margin: 0;
}

.titleModalReversalOrDelete {
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
  text-align: center;
}

.footerTitle {
  color: #0188c8;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
}

.btnsModalActions {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnConfirm {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnCancel {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #0188c8;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

.loadingLazy {
  position: absolute;
  bottom: 100px;
  height: 50vh;
  width: calc(100% - 240px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.celTableInfos {
  display: flex;
  gap: 20px;
  width: 20%;
  height: 50px;
  text-align: center;
  justify-content: flex-end;
  align-items: flex-end;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
  border-radius: 5px;
  background: rgb(238, 238, 238);
  font-size: 10px !important;
  font-weight: normal !important;
  padding: 10px;
  color: #001c29;
  margin: 0;
  height: 50px;
}

.celTableActions {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.notResult {
  max-height: 65px;
  border-radius: 50%;
  max-width: 65px;
}

.searchInputFin {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.tableAddProductsAny {
  overflow: auto;
  padding: 10px;
  gap: 1rem;
  width: 100%;
  min-height: 50vh;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(241, 241, 241);
  border-radius: 10px;
}

.anyProd {
  font-size: 18px;
  font-weight: 600;
  color: rgb(158, 158, 158);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.searchInputAll {
  display: flex;
  padding-left: 30px;
  gap: 20px;
}

.searchAll {
  justify-content: space-evenly;
  color: #3a4750;
  font-size: 12px;
  height: 30px;
  width: 120px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.searchInputAll {
  width: 30%;
  display: flex;
}

.wtsTd {
  display: flex;
  gap: 2px;
  padding-top: 5px;
  cursor: pointer;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
.input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.radio-input {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

p {
  margin-bottom: 0rem !important;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.input-group {
  width: 30%;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }
}
</style>
